module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/text/h1-f885ba5254eabf3efeb24dc0075d4d3f.svg";